import { httpApi } from '@app/api/http.api';
// import './mocks/auth.api.mock';
import { UserModel } from '@app/domain/UserModel';

export interface AuthData {
  email: string;
  password: string;
}

export interface SignUpRequest {
  // firstName: string;
  // lastName: string;
  email: string;
  password: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface SecurityCodePayload {
  code: string;
}

export interface NewPasswordData {
  newPassword: string;
  resetToken: string;
}

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginRequestGoogle {
  accessToken: string;
}

export interface LoginResponse {
  token: {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
  };
  user: UserModel;
}

export const login = (loginPayload: LoginRequest): Promise<LoginResponse> =>
  httpApi.post<LoginResponse>('auth/login', { ...loginPayload }).then(({ data }) => data);

export const loginGoogle = (loginPayload: LoginRequestGoogle): Promise<LoginResponse> =>
  httpApi.post<LoginResponse>('auth/google', { ...loginPayload }).then(({ data }) => data);

export const signUp = (signUpData: SignUpRequest): Promise<undefined> =>
  httpApi.post<undefined>('/auth/register', { ...signUpData }).then(({ data }) => data);

export const resetPassword = (resetPasswordPayload: ResetPasswordRequest): Promise<any> =>
  httpApi.post<any>('/auth/forgot-password', { ...resetPasswordPayload }).then(({ data }) => data);

export const verifySecurityCode = (securityCodePayload: SecurityCodePayload): Promise<undefined> =>
  httpApi.post<undefined>('verifySecurityCode', { ...securityCodePayload }).then(({ data }) => data);

export const setNewPassword = (newPasswordData: NewPasswordData): Promise<undefined> =>
  httpApi.put<undefined>('/auth/reset-password', { ...newPasswordData }).then(({ data }) => data);

export const changePassword = (changePasswordData: ChangePasswordData): Promise<any> =>
  httpApi.put<any>('/auth/change-password', { ...changePasswordData }).then(({ data }) => data);
